import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, Col, Container, Form, Image, InputGroup, Row } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import { LinkContainer } from 'react-router-bootstrap';
import { useParams } from 'react-router-dom';
import { Link, useNavigate } from 'react-router-dom';
import { LoginInfo } from '../App';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { rankingBgColor,rankingOpacity } from "./common/RankingUtil";
import UserInfoPopup from './common/UserInfoPopup';
import RankingHeader from './RankingHeader';
import Thumb from './common/Thumb';
import Masonry from 'react-masonry-css';
import Tile from './common/Tile';
import { isLoggin, updateRenzoku, updateTile } from '../service/LoginService';
import { Tab, Tabs } from '@mui/material';
import MuiButton from "@mui/material/Button";
import ReactGA from "react-ga4";
import Gallery from './common/Gallery';
import { imgPath } from '../service/CommonUtil';

const Ranking = () => {
    async function getImage(styleOfPainting,ageLimit,period,type,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/ranking/"+styleOfPainting+"/"+ageLimit+"/"+period+"/"+type+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getUserSetting(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/userSetting/my")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getUserInfo(userIdOrDisplayId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/"+userIdOrDisplayId)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    // ナビゲーション
    const navigate = useNavigate()

    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)

    useEffect(() => {
        if(loginInfo.result){
            // 連続投稿の表示減らす
            setOmitContinuous(loginInfo.renzoku === 1)
            // タイルモード
            setTileMode(loginInfo.tile === 1)
        }
    },[loginInfo])

    const [userSetting, setUserSetting] = useState([]);
    const [imageList,setImageList] = useState([])
    const [followUserImage,setFollowUserImage] = useState([...Array(0)])
    const [imagePage,setImagePage] = useState(1)

    // ユーザ情報ポップアップ
    const [displayId,setDisplayId] = useState()
    const [selfIntroduction,setSelfIntroduction] = useState()
    const [follow,setFollow] = useState()
    const [follower,setFollower] = useState()
    const [isFollow,setIsFollow] = useState()

    // パラメータ
    let param = useParams()
    let styleOfPainting = param.style_of_painting
    let ageLimit = param.age_limit
    let period = param.period
    let type = param.type
    let page = param.page
    const [oldPeriod,setOldPeriod] = useState(period)

    // 投稿遅延ロード
    const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05
    }
    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target;
                //imgEl.src = imgEl.dataset.src;          
                observer.unobserve(entry.target);
                // ロードした部分まで進んだら追加読み込み
                if(imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (imagePage * 100 - 1) && imagePage < 34){
                    //setImagePage(imagePage+1)
                }
              }
        })
    }, options);

    useEffect(() => {
        let tempPage = imagePage
        if(oldPeriod !== period){
            tempPage = 1
        }
        getImage(styleOfPainting,ageLimit,period,type,tempPage).then(r => {
            if(r.result){
                if(false && imageList.length > 0 && oldPeriod === period){
                    if(tempPage === 34){
                        setImageList(imageList.concat(r.data.splice(0,9)))
                    } else {
                        setImageList(imageList.concat(r.data))
                    }
                } else {
                    setImageList([].concat(r.data))
                }
            }
            setOldPeriod(period)
        })
    },[styleOfPainting,ageLimit,period,type,page,imagePage])

    useEffect(() => {
        // ユーザ設定
        getUserSetting().then(r => {
            if(r.result){
                setUserSetting(r.data)
            }
        })
        if(styleOfPainting === undefined && ageLimit === undefined && period === undefined && page === undefined){
            navigate("/ranking/illustration/general/1day/s_all/1")
            return
        }
        if(period !== undefined && page === undefined){
            navigate("/ranking/illustration/general/"+period+"/s_all/1")
            return
        }
        let ageLabel = ""
        if(ageLimit === "general"){
            ageLabel = t("common.general")
        } else if(ageLimit === "pg12"){
            ageLabel = "PG-12"
        } else if(ageLimit === "r15"){
            ageLabel = "R-15"
        } else if(ageLimit === "r18"){
            ageLabel = "R-18"
        } else if(ageLimit === "all"){
            ageLabel = t("common.all")
        }
        let periodLabel = ""
        if(period === "1day"){
            periodLabel = "1"+t("common.day")
        } else if(period === "1week"){
            periodLabel = "1"+t("common.week")
        } else if(period === "1month"){
            periodLabel = "1"+t("common.month")
        }
        let typeLabel = ""
        if(type === "s_all"){
            typeLabel = t("common.totalling") + ":" + t("common.s_all")
        } else if(type === "s_odai") {
            typeLabel = t("common.totalling") + ":" + t("common.s_odai")
        } else {
            typeLabel = t("common.totalling") + ":" + t("common.s_jogai")
        }
        // タイトル設定
        document.querySelector("title").textContent = t("ranking.name")+"("+ageLabel+") "+t("ranking.period")+":" + periodLabel + " " + typeLabel + " - "+t("common.siteName")
    },[styleOfPainting,ageLimit,period,type])

    const [omitContinuous,setOmitContinuous] = useState(false)
    const [tileMode,setTileMode] = useState(true)
    const [showSetting,setShowSetting] = useState(false)

    // 画像遅延ロード
    useEffect(() => {
        document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[imageList])

    useEffect(() => {
        ReactGA.initialize("G-7W9JKQ50Y6");
        ReactGA.send({
          hitType: "pageview",
          // アクセスしたパス (pathname) とクエリ文字列 (search) を送付する (必要に応じて編集する)
          page: "/ranking",
        })
    },[])

    // ダイアログ
    const [show, setShow] = useState(false)
    const [dialogTitle, setDialogTitle] = useState("")
    const [dialogMessage, setDialogMessage] = useState("")
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }
    const breakpointColumnsObj = {
        default: 9,
        1800: 8,
        1600: 7,
        1400: 6,
        1200: 5,
        992: 4,
        768: 3,
        576: 2,
    }
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Category />
        <div className='p-0' style={{position:"fixed",zIndex:2,width:"100%",top:"68px",backgroundColor:"inherit",overflow:"auto"}} id="category-bar">
            <div className='mt-1 mb-1' style={{width:"900px",fontSize:"24px",fontWeight:"bold",backgroundColor:"inherit"}}>
                <Tabs variant='fullWidth' value="ranking" onChange={(e) => {
                    switch(e.target.tabIndex){
                        case 0:
                            navigate("/")
                        break
                        case 1:
                            navigate("/new")
                        break
                        case 2:
                            navigate("/osusume")
                        break
                        case 3:
                            navigate("/ranking")
                        break
                        case 4:
                            navigate("/random")
                        break
                        case 5:
                            navigate("/newFollow")
                        break
                        case 6:
                            navigate("/newUser")
                        break
                    }
                    }} centered>
                    <Tab label={"Top"} value="0" tabIndex={0}></Tab>
                    <Tab label={t("home.new")} value="new" tabIndex={1} onClick={() => navigate("/new")}></Tab>
                    <Tab label={t("osusume.title")} value="osusume" tabIndex={2}></Tab>
                    <Tab label={t("category.ranking")} value="ranking" tabIndex={3}></Tab>
                    <Tab label={t("category.discover")} value="random" tabIndex={4}></Tab>
                    <Tab label={t("newFollow.title")} value="newFollow" tabIndex={5}></Tab>
                    <Tab label={t("newUser.title")} value="newUser" tabIndex={6}></Tab>
                    <Icon.GearFill
                        onClick={() => setShowSetting(!showSetting)}
                        style={{fontSize:"32px",marginLeft:"10px",marginRight:"10px",cursor:"pointer"}} />
                </Tabs>
            </div>
        </div>
        <Container style={{position:"fixed",top:"127px",zIndex:2,backgroundColor:"#FFFFFF",display:showSetting ? "block" : "none",width:"auto"}} className='p-0'>
            <Row>
                <Col xs={8} sm={8} md={7} lg={7} xl={7} xxl={7} style={{}}>
                    <InputGroup style={{}}>
                        <InputGroup.Checkbox style={{cursor:"pointer"}} checked={omitContinuous} onClick={(e) => {
                            updateRenzoku(e.currentTarget.checked ? "on" : "off").then(r => {
                                if(r.result){
                                    isLoggin().then(json => {
                                        setLoginInfo(json)
                                    })
                                }
                            })
                            //setOmitContinuous(e.currentTarget.checked)
                            }} />
                        <Form.Control type="text" value={t("common.deduceConsecutiveSubmissions")} readOnly />
                    </InputGroup>
                </Col>
                <Col xs={8} sm={8} md={5} lg={5} xl={5} xxl={5} style={{}}>
                    <InputGroup style={{}}>
                        <InputGroup.Checkbox style={{cursor:"pointer"}} checked={tileMode} onClick={(e) => {
                            updateTile(e.currentTarget.checked ? "on" : "off").then(r => {
                                if(r.result){
                                    isLoggin().then(json => {
                                        setLoginInfo(json)
                                    })
                                }
                            })
                            //setTileMode(e.currentTarget.checked)
                            }} />
                        <Form.Control type="text" value={t("common.tileMode")} readOnly />
                    </InputGroup>
                </Col>
            </Row>
        </Container>
        <div style={{position:"relative",top:"60px"}}>
            <RankingHeader loginInfo={loginInfo} />
            {false ? (
            <Container className='mt-3 mb-3' style={{fontSize:"20px",fontWeight:"bold"}}>{t("ranking.period")}：{t("common.before")}
                &nbsp;
                {period === "1day" ? "1"+t("common.day") : ""}
                {period === "1week" ? "1"+t("common.week") : ""}
                {period === "1month" ? "1"+t("common.month") : ""}
            </Container>
            ) : ""}
            <Container className='text-center'>
                {[{period:"1day",name:"1"+t("common.day")},{period:"1week",name:"1"+t("common.week")},{period:"1month",name:"1"+t("common.month")}].map((d,i) => {
                    return <LinkContainer to={"/ranking/"+styleOfPainting+"/"+ageLimit+"/"+d.period+"/"+type+"/1"} key={i}>
                        <Button variant={(period === d.period || (period === undefined && d.period === "general") ? "" : "outline-") +"secondary"} className='m-2'>{d.name}</Button>
                        </LinkContainer>
                })}
            </Container>
            <Container className='mb-3'>
                <MuiButton variant='outlined' onClick={() => navigate('/rankingOthers')}>その他のランキング</MuiButton>
            </Container>
            {ageLimit === "r18" && loginInfo.result && loginInfo.r18_display_flag === 1 ? (
                <Link to="/generate_unlimit" className='d-flex justify-content-center'><Alert className="p-1 text-center" style={{display:"inline-block"}}>R18画像生成：コインで制限解除<br /><Image src="/img/unlimit/ad2.webp" width={240} /></Alert></Link>
            ) : ""}
            <h5 style={{display:imageList.length > 0 && imageList[0].is_temp ? "block" : "none"}}>暫定版(いいね未集計)</h5>
            {tileMode ? (
                <div>
                {/*<Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="my-masonry-grid"
                    columnClassName="my-masonry-grid_column"
                    >
                    {imageList.filter((d,i) => i < 3).map((data,i) => {
                        if(data.mute === 1 || (omitContinuous && param.general_or_ai !== "test" && i > 0 && imageList[i-1].user_id === data.user_id) || (data.user_id !== loginInfo.userId && data.search_ban === 1)){
                            return <span data-no={i} className="lazy" key={i}></span>
                        }
                        return <Tile data={data} i={i} dialog={dialog} key={i} observer={observer} list={imageList} listName={t(("category.ranking"))} rank={i} />
                    })}
                </Masonry>*/}
                <div style={{maxWidth: "1200px"}}>
                <Gallery images={imageList.filter((d,i) => i < 3).map(d => {
                    d.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST + imgPath("image") + '/post/t/'+(d.id)+"_m"+ApiFetch.API_THUMB_EXT
                    d.aspect = d.width/d.height
                    console.log(d.aspect)
                    return d
                }).map((d,i) => {
                    if(d.mute === 1 || (omitContinuous && param.general_or_ai !== "test" && i > 0 && imageList[i-1].user_id === d.user_id) || (d.user_id !== loginInfo.userId && d.search_ban === 1)){
                        d.isMute = true
                    } else {
                        d.isMute = false
                    }
                    return d
                })} alignItems='left' dialog={dialog} listName={t(("category.ranking"))} showRank={true} />
                </div>
                {/*<Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="my-masonry-grid"
                    columnClassName="my-masonry-grid_column"
                    >
                    {imageList.filter((d,i) => i > 2).map((data,i) => {
                        i += 3
                        if(data.mute === 1 || (omitContinuous && param.general_or_ai !== "test" && i > 0 && imageList[i-1].user_id === data.user_id) || (data.user_id !== loginInfo.userId && data.search_ban === 1)){
                            return <span data-no={i} className="lazy" key={i}></span>
                        }
                        return <Tile data={data} i={i} dialog={dialog} key={i} observer={observer} list={imageList} listName={t(("category.ranking"))} />
                    })}
                </Masonry>*/}
                <div className='m-3' />
                <Gallery images={imageList.filter((d,i) => i > 2).map(d => {
                    d.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST + imgPath("image") + '/post/t/'+(d.id)+"_m"+ApiFetch.API_THUMB_EXT
                    d.aspect = d.width/d.height
                    console.log(d.aspect)
                    return d
                }).map((d,i) => {
                    if(d.mute === 1 || (omitContinuous && param.general_or_ai !== "test" && i > 0 && imageList[i-1].user_id === d.user_id) || (d.user_id !== loginInfo.userId && d.search_ban === 1)){
                        d.isMute = true
                    } else {
                        d.isMute = false
                    }
                    return d
                })} dialog={dialog} listName={t(("category.ranking"))} startIndex={3} />
                </div>
            ) : (
            <div className='d-flex flex-row justify-content-start flex-wrap w-100'>
                {imageList.map((data,i) => {
                    if(data.mute === 1 || (omitContinuous && param.general_or_ai !== "test" && i > 0 && imageList[i-1].user_id === data.user_id) || (data.user_id !== loginInfo.userId && data.search_ban === 1)){
                        return <span data-no={i} className="lazy" key={i}></span>
                    }
                return <Thumb data={data} i={i} dialog={dialog} key={i} observer={observer} list={imageList} listName={t(("category.ranking"))} rank={i} />
                })}
            </div>
            )}
        </div>
        <div style={{marginBottom: "100px"}} />
        <Footer />
    </div>
    )
}

export default Ranking;
